import { useState } from "react";
import { Layout, Select, Spin, Upload } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
// import "../Adjustments/Adjustments.css";
import "../../GlobalCss/SPF/Adjustments.css";
import Navbar from "../../Components/Support/Header";
import { DeleteOutlined, LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import AdjustmentsGrid from "../../Components/Adjustments/AdjustmentsGrid";
import { ErrorMessage, ReplaceUnderscoreWithSpace, StringValidations, SuccessMessage } from "../../Utils/Utils";
import { FetchAdjustmentsData, FetchHistoricAdjustmentsData, PostAdjustmentsExcel } from "../../Repository/AdjustmentsRepository";
import GetHistoricAdjustments from "../../Components/Adjustments/HistoricAdjustments";
const { Header } = Layout;

const Adjustments = () => {
  const [dataSource, setDataSource] = useState([]);
  const [PayFrequency, setPayFrequency] = useState("");
  const [loadGrid, setLoadGrid] = useState(false);
  const [FileList, setFileList] = useState([]);
  const [loadUploading, setLoadUploading] = useState(false);
  const [dateValue, setDateValue] = useState("");
  const [dynamicColumns, setDynamicColumns] = useState({ DefaultHeaders: [], EADCodes: [] });
  const [selectedColumns, setSelectedColumns] = useState([]);

  const handleFrequencyChange = async (frequency) => {
    if (StringValidations(frequency)) {
      setPayFrequency(frequency);
      if (StringValidations(dateValue)) {
        await FetchHistoricAdjustmentsData(dateValue, frequency, setLoadGrid, setDataSource);
      }
      else {
        await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
      }
      
    }
  }

  // File List rendering
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (FileList.length > 0) {
      fileExists = true;
    }
    return <>
      <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? FileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>
    </>;
  };

  //Handling on uploading Adjustment Excel
  const handleAdjustmentExcelUpload = async (options) => {
    setLoadUploading(true);
    const { file } = options;
    setFileList([{ file, status: "uploading" }]);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const Response = await PostAdjustmentsExcel(PayFrequency, formData);
      if (Response.statusCode === 200) {
        SuccessMessage(Response.message);
        setFileList([{ file, status: "done" }]);
        await FetchAdjustmentsData(PayFrequency, setLoadGrid, setDataSource);
      }
      else {
        ErrorMessage(Response.message);
        setFileList([{ file, status: "error" }]);
      }
    }
    catch (error) {
      setFileList([{ file, status: "error" }]);
      ErrorMessage(error);
    }
    finally {
      setLoadUploading(false);
    }
  }


  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <SideNavBar />
      <Layout style={{ background: "white", overflow: "hidden" }}>
        <Header className="adjustments-navbar">
          <Navbar />
        </Header>
        <div class={`adjustments-body ${StringValidations(PayFrequency)?"":"block-adjustments-page"}`}>
          <div className="adjustments-main-section">
            <div className="adjustments-heading">Payroll Adjustments</div>
            <Select
              className="adjustments-frequency-selector"
              placeholder={<span className="grey-placeholder">Select Pay Frequency</span>}
              onSelect={(value) => handleFrequencyChange(value)}
            >
              <Select.Option key={"W"} value={"W"}>Weekly</Select.Option>
              <Select.Option key={"B"} value={"B"}>Bi-Weekly</Select.Option>
            </Select>
            <div className="adjustments-upload-excel">
              <Upload.Dragger
                accept=".xlsx"
                customRequest={handleAdjustmentExcelUpload}
                itemRender={itemRender}
                fileList={FileList}
                onRemove={() => setFileList([])}
                style={{ border: `1px dashed ${StringValidations(PayFrequency)?"#002766":"#D9D9D9"}`, borderRadius: 10,
                maxWidth: '100%',
                display: 'flex',
                flexDirection: 'row', 
                flexWrap: 'wrap', 
                justifyContent: 'center',
                textOverflow:"ellipsis",
                overflow:'hidden',
                whiteSpace:'nowrap',
                }}
              >
                <div className={`adjustments-upload-excel-placeholder  ${StringValidations(PayFrequency)?"":"disable-upload"}`} >
                  <span>Adjustment Upload</span>

                  {loadUploading ? (
                    <Spin
                      indicator={
                        <div style={{ alignItems: "center" }}>
                          <LoadingOutlined />
                        </div>
                      }
                    ></Spin>
                  ) : (
                    <UploadOutlined className={`adjustments-upload-excel-icon  ${StringValidations(PayFrequency)?"":"disable-upload"}`} />
                  )}
                </div>
              </Upload.Dragger>
            </div>
          </div>
          <div className="adjustments-grid-header-section">
            <AdjustmentsGrid
              loadGrid={loadGrid}
              setLoadGrid={setLoadGrid}
              dataSource={dataSource}
              setDataSource={setDataSource}
              frequency={PayFrequency}
              payDate={dateValue}
              dynamicColumns={dynamicColumns}
              setDynamicColumns={setDynamicColumns}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              HistoricJSX={() => <GetHistoricAdjustments frequency={PayFrequency} setLoadGrid={setLoadGrid} setDataSource={setDataSource} dateValue={dateValue} setDateValue={setDateValue} />} />
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export default Adjustments;
